module.exports = __webpack_public_path__ + "img/sbk.da60dac8.png";